const $ = require('jquery');
const { hasAvailability } = require("./helpers");
const { updateFormSummary } = require("../service-form/service-form");
const { getSelectedSubproduct, showSubproduct, setDefaultSubproduct, updateBookingAction} = require('./subproducts-selection');

function getServicePrices(e = null) {
    return new Promise((resolve) => {
        if (currentPriceAjaxRequest !== null) {
            currentPriceAjaxRequest.abort();
        }
        if (e !== null) {
            e.preventDefault();
        }

        var requestData = {
            action: 'get-service-prices',
            service_id: $('#service_id').val(),
            channel: 'KD_WWW',
            people_quantity_adult: $('#people_quantity_adult').val(),
            people_quantity_youth: $('#people_quantity_youth').val(),
            people_quantity_children: $('#people_quantity_children').val(),
            private_or_group: $('#private_or_group').val(),
            request_source: 'KD_WWW',
            company_shortcut: 'KD',
            type_of_transfer: !$('#type_of_transfer').val() ? 3 : $('#type_of_transfer').val(),
            tour_date: $('#tour_date').val(),
            pickup_type: !$('#pickup_type').val() ? 'HOTEL' : $('#pickup_type').val(),
            tour_lang: !$('#tour_lang').val() ? 'ANG' : $('#tour_lang').val()
        };

        currentPriceAjaxRequest = $.ajax({
            url: '/wp-admin/admin-ajax.php', type: 'GET', data: requestData, dataType: 'JSON', beforeSend: function () {
                $('#serviceOrderForm').attr('data-price-loading', 'true');
                updateBookingAction();
                $('.subproduct-price').html('<i class="fa fa-spinner fa-spin"></i>');
                $('.form-summary #totalPrice').html('<i class="fa fa-spinner fa-spin"></i>');
            }, success: function (response) {
                if (response.success) {
                    var currency = $('#currency').val();
                    $('#serviceOrderForm').removeAttr('data-price-loading');
                    resolve(updatePrices(response.data, currency));
                } else {
                    showPriceFailure();
                    resolve(null);
                }
            }, error: function (xhr, status, error) {
                if (status === 'abort') {
                    resolve(null);
                    return;
                }
                console.error('Unable to load service prices:', error);
                showPriceFailure();
                resolve(null);
            }
        });
    });
}

function showPriceFailure() {
    $('#serviceOrderForm').removeAttr('data-price-loading');
    $('.subproduct').addClass('unavailable');
    $('.subproduct-price, .form-summary #totalPrice').text('N/A');
    $('.subproductsListComponent .preloadMask').fadeOut(300);
    setDefaultSubproduct();
}

function updatePrices(pricesData, currency) {
    $('.subproduct').removeClass('unavailable');
    $('.subproduct').each(function () {
        $(this).removeClass('d-none');
        var serviceId = $(this).data('service-id');
        var privacyType = $(this).data('privacy-type') === 'Private' ? 'Private' : 'Group';
        var priceContainer = $(this).find('.subproduct-price');
        var priceData = pricesData[serviceId];
        var priceType = priceData && (privacyType === 'Group' ? priceData.group : priceData.private);
        var price = priceType && priceType[currency];
        var available = hasAvailability(serviceId, privacyType);
        if (!available || !(Number(price) > 0)) {
            $(this).addClass('unavailable');
            if($(this).data('hide-unavailable') == 1) {
                $(this).addClass('d-none');
            }
            if($(this).hasClass('selected')) {
                showSubproduct()
            }
            priceContainer.text(available ? 'N/A' : 'Sold Out!');
            return;
        }

        priceContainer.text(`${price} ${currency}`);
        if (getSelectedSubproduct() && serviceId == getSelectedSubproduct().service_id && privacyType == $('#private_or_group').val()) {
            updateFormSummary(`${price} ${currency}`);
        }
    });
    $('.subproductsListComponent .form-summary').fadeIn(500);
    $('.subproductsListComponent .preloadMask').fadeOut(300);
    updateBookingAction();
}

let currentPriceAjaxRequest = null;

module.exports = { getServicePrices, updatePrices };
